import React from "react";
import { useNavigate } from "react-router-dom";
import { teamMembers } from "../Data/teamData";
import "./corporate.css";

const BM = () => {
  const navigate = useNavigate();

  return ( 

      <>

          <div className="team-banner">
            <img src="/corporate/BOD.png" alt="" />
          </div>

    <section className="team-page">


           <div className="team-intro">
            <h1>Board Members</h1>
            <p>At our company, we are fortunate to have an exceptional team of highly skilled and creative individuals who are dedicated to achieving our goals with outstanding performance. Each team member is committed to the pursuit of excellence, and their collective efforts have been instrumental in driving the growth and development of our company.</p>
           </div>


      <div className="team-grid">
        {teamMembers.map((member) => (
          <div
            className="team-card"
            key={member.id}
            onClick={() => navigate(`/team/${member.id}`)}
          >
            <img src={member.img} alt={member.name} />
            <div className="team-info">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
      </>
  );
};

export default BM;
